var createReactClass = require('create-react-class');
import React from 'react';

const NewModal = createReactClass({
  getInitialState: function() {
    return {
      label: "",
      description: "",
      tooltip: "",
    }
  },

  newReason: function() {
    $.ajax({
      type: 'POST',
      url: this.props.newPath,
      data: {deferral_reason: {label: this.state.label, description: this.state.description, tooltip: this.state.tooltip}, type: this.props.type},
      dataType: 'json',
      success: function(res){
        window.location.reload()
      },
      error: function(res) {
        Cureus.Flash.alert('There was an issue, please try later.')
      }
    })
  },

  handleInputChange: function(e) {
    this.setState({[e.target.name]: e.target.value})
  },

  titleButtonText: function() {
    return "Create " + this.props.buttonText;
  },

  render: function() {
    let editorApprovalTable = this.props.type === "EditorApprovalRejectionReason"
    return (
      <div className="reveal-modal middling" data-reveal id="edit-deferral-reason">
        <div className="modal-body">
          <div className='modal-close'>
            <a href='#' className='cancel-modal'>
              <img src="https://public.cureus.com/close_x.png"/>
            </a>
          </div>
          <div className="modal-content middling">
            <h4>{this.titleButtonText()}</h4>
            <label htmlFor='label' id="label">Label</label>
            <input type="text" name="label" onChange={this.handleInputChange}  required='required'/>

            {editorApprovalTable &&
              <>
                <label htmlFor='tooltip'>Tooltip</label>
                <textarea name="tooltip" style={{height: '100px'}} onChange={this.handleInputChange} id='tooltip'/>
              </>
            }

            <label htmlFor='description'>Description</label>
            <textarea name="description" style={{height: '300px'}} onChange={this.handleInputChange} id='description'/>
          </div>
          <div className='modal-footer'>
            <a className='cancel-modal button small secondary'>Cancel</a>
            <a className="button small primary success" onClick={this.newReason}>{this.titleButtonText()}</a>
          </div>
        </div>
      </div>
    )
  }
});

export default NewModal;